"use client";

import { useContext } from "react";

import { StoreContext } from "@components/store/provider";

import { getMenuRoute } from "@constants/routes";
import { ANALYTICS_TARGET_VIEW_ALL_PRODUCTS } from "./constant";

import { ExternalButton } from "@sharedComponents/buttons";

import styles from "./main.module.scss";

const ViewAllProductsCTA = ({ eventLocationAnalytics }) => {
  const { storeBasePath } = useContext(StoreContext);

  return (
    <div className={styles.btnBlock}>
      <ExternalButton
        styleType="primary"
        href={getMenuRoute({ storeBasePath })}
        aria-label="View All Products"
        eventLocationAnalytics={{
          target: ANALYTICS_TARGET_VIEW_ALL_PRODUCTS,
          track: true,
          eventProperties: eventLocationAnalytics?.eventProperties ?? {},
        }}
      >
        View All Products
      </ExternalButton>
    </div>
  );
};

export default ViewAllProductsCTA;
